module.exports = __webpack_public_path__ + "img/hudsonmann.531f5690.png";